import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { useShowTradeConfirmation } from "#/store/app/portfolio/settings/showTradeConfirmation";
import { confirmTrade } from "#/utils/modals/confirmTrade";

import { useComboTradeButtonController } from "./ComboTradeButton.controller";
import { CountdownButton } from "./components/CountdownButton/CountdownButton";
import { Instruments } from "./components/Instruments/Instruments";
import { PortfolioImpactAndGreeks } from "./components/PortfolioImpactAndGreeks/PortfolioImpactAndGreeks";

const TradeButtonWithClose: React.FC<{ handleClose: () => void }> = ({
  handleClose,
}) => {
  const { handleSubmit } = useComboTradeButtonController(handleClose);

  return <CountdownButton seconds={30} onClick={handleSubmit} />;
};

export const ComboTradeButton: React.FC = () => {
  const { buttonLabel, isLoading, isDisabled, handleSubmit } =
    useComboTradeButtonController();
  const { showTradeConfirmation } = useShowTradeConfirmation();

  const handleClick = () => {
    if (!showTradeConfirmation) {
      handleSubmit();
      return;
    }

    confirmTrade({
      header: "Combo Order - Orderbook",
      children: (
        <div className="mb-4 grid gap-2">
          <Instruments />
          <PortfolioImpactAndGreeks />
        </div>
      ),

      tradeButton: ({ handleClose }) => (
        <TradeButtonWithClose handleClose={handleClose} />
      ),
    });
  };

  return (
    <ConnectWalletWrapper>
      <Button
        size="lg"
        isLoading={isLoading}
        disabled={isDisabled || isLoading}
        className="min-w-37.5 text-[15px] shadow-none"
        onClick={handleClick}
      >
        {buttonLabel}
      </Button>
    </ConnectWalletWrapper>
  );
};
